import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * ResourceHints Component
 * Adds DNS prefetch, preconnect, and other resource hints to improve performance
 */
export const ResourceHints = () => {
  useEffect(() => {
    // Preload critical fonts
    const fontLinks = document.querySelectorAll('link[rel="preload"][as="font"]');
    if (fontLinks.length === 0) {
      // Add font preloading if not already present
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'font';
      link.type = 'font/woff2';
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <Helmet>
      {/* DNS Prefetch for external domains */}
      <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
      <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
      
      {/* Preconnect to critical origins */}
      <link rel="preconnect" href={import.meta.env.VITE_SUPABASE_URL} crossOrigin="anonymous" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* Stripe preconnect (for checkout pages) */}
      <link rel="dns-prefetch" href="https://js.stripe.com" />
      <link rel="dns-prefetch" href="https://api.stripe.com" />
      
      {/* Sentry preconnect (for error tracking) */}
      <link rel="dns-prefetch" href="https://browser.sentry-cdn.com" />
    </Helmet>
  );
};
